import { inject, Injectable } from '@angular/core';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { ViewStateTypes } from '@src/suite/common/enums/viewstate-types';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { NOMDatabase } from '@src/suite/common/store/records/records.models';

import { TemplatesSearchService } from './templates.search.service';

@Injectable({ providedIn: 'root' })
export class TemplatesService {
    globalTablesService = inject(GlobalTablesService);
    templatesSearchService = inject(TemplatesSearchService);

    constructor() {
        this.globalTablesService.getFiltersForViewStateType[ViewStateTypes.TEMPLATES] = this.getFiltersForTemplates().bind(this);
        this.globalTablesService.getFiltersForViewStateType[ViewStateTypes.TEMPLATESSEARCH] = this.getFiltersForTemplates().bind(this);
    }

    public getFiltersForTemplates(): (item: FieldDef) => boolean {
        return (item: FieldDef) => {
            // For now we support only rundown templates, so the filter is equal to live filters, but we can change it in the future if needed
            if (item.ID !== PSTFieldNames.TrashTime && item.Briefable && (item.RundownProp === true || item.Type?.includes('RO Property'))) {
                return true;
            }
            return false;
        };
    }

    public loadTemplatesObjectsObservable(vs?: StorytellingViewStateRecord, database?: NOMDatabase) {
        return this.templatesSearchService.getTemplatesResultsObservable(vs, database);
    }
}
